// extracted by mini-css-extract-plugin
export var close = "styles-module__close___c42Vx";
export var enterDone = "styles-module__enterDone___bBN1m";
export var exit = "styles-module__exit___OdFDM";
export var modal = "styles-module__modal___z8BbR";